import { forwardRef, type InputHTMLAttributes } from 'react';

import { useFieldControl } from './fieldContext';
import styles from './control.module.css';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  /** Set when the control is used outside a `Field` and validity has to be passed explicitly. */
  invalid?: boolean | undefined;
  className?: string | undefined;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  const field = useFieldControl();
  const isInvalid = invalid ?? field?.invalid ?? false;

  return (
    <input
      {...rest}
      ref={ref}
      id={rest.id ?? field?.controlId}
      aria-describedby={rest['aria-describedby'] ?? field?.describedBy}
      aria-invalid={isInvalid || undefined}
      aria-required={(rest.required ?? field?.required) === true ? true : undefined}
      required={rest.required ?? field?.required ?? false}
      disabled={rest.disabled ?? field?.disabled ?? false}
      className={[styles.control, className].filter(Boolean).join(' ')}
    />
  );
});
